// Platform/Feature detection



// Will be true while react-snap is statically rendering the app. Can be used (sparingly) to disable/enable
// features only visible to the static renderer.
export const staticGenerator = navigator.userAgent === 'ReactSnap';


// NOTE: Relying on platform detection is generally a bad decision, as responsive design and feature detection
// often yield better and more accurate results (source: see the internet). There are still times where platform
// specific behavior (like scrolling behavior on iOS) isn't directly detectable, and knowing the platform helps
// develop a better experience everywhere. That is why this (relatively simple) platform detection exists at all.
// It probably is a good idea to attempt to keep this RegEx detection up-to-date.

// Detects iOS. Check for MSStream is due to IE11 including 'iPhone' in its userAgent (??)
export const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

// Detects Android
export const android = /android/i.test(navigator.userAgent);

// Detects a mobile device (phone or tablet)
// This is most useful for prioritizing touch over mouse interaction
export const mobile = iOS || android;



// WEBPACK FOOTER //
// ./src/helpers/detect.js